import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Global hook to handle Media Library "Open on Site" preview highlighting.
 * Looks for ?ml_preview=destination.key query param and scrolls/highlights
 * the matching [data-destination] element.
 */
export const useMediaPreviewHighlight = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const previewKey = params.get('ml_preview');
    
    if (!previewKey) return;

    // Small delay to ensure DOM is ready after route change
    const timer = setTimeout(() => {
      // Remove any existing highlights
      document.querySelectorAll('.ml-preview-highlight').forEach(el => {
        el.classList.remove('ml-preview-highlight');
      });

      // Find and highlight the target section
      const section = document.querySelector(`[data-destination="${previewKey}"]`);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth', block: 'center' });
        section.classList.add('ml-preview-highlight');
      }
    }, 150);

    return () => clearTimeout(timer);
  }, [location.search]);
};
